var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardEnterProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.312,
    height: 35.312,
    viewBox: "0 0 35.312 35.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160787",
    "data-name": "Group 160787",
    transform: "translate(-12947 529.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email_sent_icon",
    "data-name": "Email sent icon",
    transform: "translate(12947 -529.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160780",
    "data-name": "Group 160780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M17.647,0A17.656,17.656,0,1,1,0,17.675,17.684,17.684,0,0,1,17.647,0M2.942,17.637A14.713,14.713,0,1,0,17.662,2.942,14.74,14.74,0,0,0,2.942,17.637",
    transform: "translate(0 0)",
    fill: "#c9c9c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Contacts_Outline_24px",
    transform: "translate(12948.794 -524.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contacts_Outline_24px-2",
    "data-name": "Contacts_Outline_24px",
    transform: "translate(0 -0.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    width: 31,
    height: 31,
    transform: "translate(0.206 0.206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    width: 28,
    height: 28,
    transform: "translate(1.206 2.206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M17.933,7.117A4.837,4.837,0,1,1,13.1,2.28h0A4.827,4.827,0,0,1,17.92,7.117Z",
    transform: "translate(2.422 1.758)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M13.842,19.878S7.05,19.528,5.93,26.32",
    transform: "translate(1.936)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M5.93,19.878s6.792-.35,7.912,6.442",
    transform: "translate(9.705)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEnterProfileIcon);
export default __webpack_public_path__ + "static/media/dashboard-enter-profile-icon.73882801a98acb561c3f96be9f83deef.svg";
export { ForwardRef as ReactComponent };